
























































import { PropType } from 'vue';
import { TimeslotModel } from '../../../../shared/models/timeslot.model';
import Icon from '../../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../../shared/enums/iconClassEnum';
import { DateTimeUtil } from '../../../../shared/utils/dateTimeUtil';
import upperFirst from 'lodash/upperFirst';
import CalendarOrganizerMeetingSlot from '../../../../shared/PageFragments/CalendarEvent/CalendarOrganizerMeetingSlot.vue';
import { EventInviteeModel } from '../../../../shared/models/eventInvitee.model';
import CalendarInviteeMeetingSlot from '../../../../shared/PageFragments/CalendarEvent/CalendarInviteeMeetingSlot.vue';
import { InstitutionProfileModel } from '../../../../shared/models/institutionProfile.model';
import { calculateNumberOfAvailableSlots } from '../../../../shared/utils/timeslotUtil';
import { types } from '../../../store/types/types';
import { mapGetters } from 'vuex';

export default {
  components: { CalendarInviteeMeetingSlot, CalendarOrganizerMeetingSlot, Icon },
  props: {
    timeslot: { type: Object as PropType<TimeslotModel>, required: true },
    invitees: { type: Array as PropType<EventInviteeModel[]>, required: true },
    numberOfParticipantsPerTimeSlot: { type: Number, default: 1 },
    canOrganize: { type: Boolean, default: false },
    canRespond: { type: Boolean, default: false },
    regardingProfile: { type: Object as PropType<InstitutionProfileModel>, default: null },
  },
  emits: ['assign', 'block', 'clear'],
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    slotDate() {
      return upperFirst(DateTimeUtil.formatDate(this.timeslot.startDate, 'ddd. DD. MMM. YYYY'));
    },
    location() {
      return this.timeslot.primaryResource?.displayName ?? this.timeslot.primaryResourceText;
    },
    numberOfAvailableSlots() {
      return calculateNumberOfAvailableSlots(this.timeslot, this.numberOfParticipantsPerTimeSlot);
    },
    slotIndexes() {
      return this.timeslot.timeSlotIndexes;
    },
    shouldShowTimeSlotHeader() {
      this.numberOfParticipantsPerTimeSlot === 1 || this.canOrganize;
    }
  },
  methods: {
    async handleSlotAssigned(index: number, invitee?: EventInviteeModel) {
      const warningKey = invitee ? 'warning.confirm_assigning_slot' : 'warning.confirm_blocking_slot';
      const isConfirmed = await this.$confirmAction(this.$t(warningKey));
      const payload = { timeslotId: this.timeslot.id, timeslotIndex: index, invitee };
      if (!isConfirmed) {
        return;
      }
      if (invitee) {
        this.$emit('assign', payload);
      } else {
        this.$emit('block', payload);
      }
    },
    emitSlotCleared(index: number, invitee?: EventInviteeModel) {
      const payload = { timeslotId: this.timeslot.id, timeslotIndex: index, invitee };
      this.$emit('clear', payload);
    },
    getAnswers(index: number) {
      return this.timeslot.answers.filter(answer => answer.selectedTimeSlotIndex === index);
    },
  },
};
